<script>
  export let src = "/images/profile_pic.jpg";
  export let alt = "A guy (me) posing with a an Amazon t-shirt with the Columbia Icefield in the background.";
</script>

<div class="relative group">
  <!-- Image Container with Effects -->
  <div 
    class="relative z-10 rounded-3xl overflow-hidden 
    transform transition-all duration-500 ease-out 
    group-hover:scale-[1.02] group-hover:rotate-[2deg] group-hover:translate-y-[-5px]
    perspective-1000"
  >
    <!-- Glow Effect -->
    <div 
      class="absolute -inset-1 bg-gradient-to-r from-blue-500 to-purple-500 
      rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition duration-1000"
    ></div>

    <!-- Image -->
    <div 
      class="relative rounded-3xl overflow-hidden bg-white/90 dark:bg-gray-800/90 
      backdrop-blur-xl p-2 border border-white/20 group-hover:shadow-xl"
    >
      <!-- Shimmer Overlay -->
      <div 
        class="absolute inset-0 w-[200%] translate-x-[-100%] z-20
        bg-gradient-to-r from-transparent via-white/30 to-transparent
        group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out"
      ></div>

      <img
        loading="lazy"
        class="w-full h-auto rounded-2xl relative z-10
        transform transition-transform duration-500
        group-hover:scale-[1.03]"
        {src}
        {alt}
      />
    </div>
  </div>
</div>

<style>
  .perspective-1000 {
    perspective: 1000px;
  }
</style> 